export default __webpack_public_path__ + "static/CustomerPic2-d0da151fc9ec195bbf554e3527ab9b58.png";